import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CustomThemeProvider } from './contexts/ThemeContext';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import AdminPanel from './components/AdminPanel';
import ProtectedRoute from './components/ProtectedRoute';
import GoogleSheetsIntegrationTest from './components/GoogleSheetsIntegrationTest';
import ServerStatus from './components/ServerStatus';
import Settings from './components/Settings';
import { CssBaseline } from '@mui/material';

function App() {
  return (
    <CustomThemeProvider>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            
            <Route path="/admin" element={
              <ProtectedRoute requireAdmin={true}>
                <AdminPanel />
              </ProtectedRoute>
            } />
            
            {/* Server Status Page - Admin Only */}
            <Route path="/server-status" element={
              <ProtectedRoute requireAdmin={true}>
                <ServerStatus />
              </ProtectedRoute>
            } />
            
            {/* Settings Page */}
            <Route path="/settings" element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            } />
            
            {/* Google Sheets Integration Test */}
            <Route path="/sheets-test" element={<GoogleSheetsIntegrationTest />} />
            
            {/* Redirect root to dashboard, which will redirect to login if not authenticated */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            
            {/* Catch all other routes and redirect to dashboard */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </CustomThemeProvider>
  );
}

export default App;
